import React, { useState, useEffect } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import MaterialBox from '../../../components/MaterialBox'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialSelect from '../../../components/MaterialSelect'
import MaterialInput from '../../../components/MaterialInput'
import './Bugs.css'
import MaterialButton from '../../../components/MaterialButton'
import { fetchData, fetchDataById, patchData } from '../../Utils/Baseurl'

const BugList = () => {
    // State for bug data
    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    // State for action options
    const [actionOptions, setActionOptions] = useState([]);

    console.log(actionOptions, 'actionOptions')

    const [projectOptions, setProjectOptions] = useState([]);
    const [project, setProject] = useState(null);

    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 15;

    const [openReasonDialog, setOpenReasonDialog] = useState(false);
    const [reasonText, setReasonText] = useState("");
    const [selectedBugId, setSelectedBugId] = useState(null);

    useEffect(() => {
        fetchProjects();
        fetchActionChoices();
    }, []);

    const fetchActionChoices = async () => {
        try {
            const response = await fetchData('api/testcase_choices/');

            const choices = response.action || [];

            const options = choices.map(item => ({
                value: item.value,
                label: item.label
            }));
            setActionOptions(options);
        } catch (error) {
            console.error("Error fetching action choices:", error);
        }
    }


    useEffect(() => {
        if (project && project.value) {
            setCurrentPage(1);
            fetchBugs(project.value, 1);
        }
    }, [project]);

    const fetchProjects = async () => {
        try {
            const response = await fetchDataById('api/get_employee_projects/?user_id=1');
            if (response && response.data) {
                const options = response.data.map(item => ({
                    value: item.project_id,
                    label: item.project_name
                }));
                setProjectOptions(options);
                if (options.length > 0) {
                    setProject(options[0]);
                }
            }
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    }

    const fetchBugs = async (projectId, page = 1) => {
        try {
            const user_id = sessionStorage.getItem('currentUser');
            const response = await fetchDataById(`api/bug_list/${user_id}/?project_id=${projectId}&page=${page}`);
            if (response && response.data) {
                const mappedData = response.data.map(bug => ({
                    id: bug.id,
                    case_id: bug.case_id || "-",
                    bugName: bug.title || bug.bug_name || "Unknown Bug",
                    module: bug.module_name || "General",
                    priority: bug.priority || "Medium",
                    owner: bug.owner_name || "Unknown",
                    // assigned: bug.assigned_name || "", // Logic kept in API map but unused
                    action: bug.action || "Pending",
                    project: bug.project_name || "Unknown"
                }));
                setData(mappedData);
                setTotalCount(response.count || 0);
            } else {
                setData([]);
                setTotalCount(0);
            }
        } catch (error) {
            console.error("Error fetching bugs:", error);
            setData([]);
            setTotalCount(0);
        }
    }

    const handleActionChange = async (id, option) => {
        const value = option ? option.value : '';

        if (value === "NOT A BUG") {
            setSelectedBugId(id);
            setReasonText("");
            setOpenReasonDialog(true);
        } else {
            try {
                await patchData(`api/testcase/${id}/`, { action: value });
                const updated = data.map((row) =>
                    row.id === id ? { ...row, action: value } : row
                );
                setData(updated);
            } catch (error) {
                console.error("Error updating action:", error);
            }
        }
    };

    const handleReasonSubmit = async () => {
        if (selectedBugId) {
            try {
                await patchData(`api/testcase/${selectedBugId}/`, { action: "NOT A BUG", description: reasonText });
                const updated = data.map((row) =>
                    row.id === selectedBugId ? { ...row, action: "NOT A BUG", notABugReason: reasonText } : row
                );
                setData(updated);
            } catch (error) {
                console.error("Error updating reason:", error);
            }
        }
        handleReasonClose();
    }

    const handleReasonClose = () => {
        setOpenReasonDialog(false);
        setSelectedBugId(null);
        setReasonText("");
    }

    const totalPages = Math.ceil(totalCount / rowsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
            if (project && project.value) {
                fetchBugs(project.value, newPage);
            }
        }
    }

    const handlePrev = () => handlePageChange(currentPage - 1);
    const handleNext = () => handlePageChange(currentPage + 1);

    return (
        <DashboardLayout>
            <Grid container direction='column' gap={2} p={1}>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                        <MaterialTypography variant='h4' color='dark' sx={{ fontWeight: 'bold' }}>Bugs List</MaterialTypography>
                        <MaterialTypography variant='caption' color='secondary'>List of bugs you can view here.</MaterialTypography>
                    </MaterialBox>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <div className="table-container">
                        <MaterialBox sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2, gap: 2 }}>
                            <MaterialBox sx={{ minWidth: '200px' }}>
                                <MaterialSelect
                                    value={project}
                                    options={projectOptions}
                                    onChange={(option) => setProject(option)}
                                    size="small"
                                    placeholder="Select Project"
                                />
                            </MaterialBox>
                            <MaterialInput
                                placeholder="Search bugs..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setCurrentPage(1);
                                }}
                                size="small"
                                sx={{ maxWidth: '300px' }}
                            />
                        </MaterialBox>

                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Bug Name</th>
                                    <th>Module</th>
                                    <th>Priority</th>
                                    <th>Owner</th>
                                    <th style={{ width: '200px' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.case_id}</td>
                                            <td>{row.bugName}</td>
                                            <td>{row.module}</td>
                                            <td>{row.priority}</td>
                                            <td>{row.owner}</td>
                                            <td>
                                                <MaterialSelect
                                                    value={{ value: row.action, label: row.action }}
                                                    options={actionOptions}
                                                    onChange={(option) => handleActionChange(row.id, option)}
                                                    size="small"
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    customStyles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center", color: "#888", padding: '20px' }}>
                                            No results found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <div className="pagination">
                            <Button onClick={handlePrev} disabled={currentPage === 1} size="small" variant="outlined">
                                Previous
                            </Button>

                            {[...Array(totalPages)].map((_, i) => (
                                <Button
                                    key={i + 1}
                                    variant={currentPage === i + 1 ? "contained" : "text"}
                                    color={currentPage === i + 1 ? "primary" : "inherit"}
                                    onClick={() => handlePageChange(i + 1)}
                                    size="small"
                                    sx={{ minWidth: '32px' }}
                                >
                                    {i + 1}
                                </Button>
                            ))}

                            <Button onClick={handleNext} disabled={currentPage === totalPages} size="small" variant="outlined">
                                Next
                            </Button>
                        </div>
                    </div>
                </Grid>
            </Grid>


            <Dialog
                open={openReasonDialog}
                onClose={handleReasonClose}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>Reason for Not a Bug</DialogTitle>
                <DialogContent>
                    <MaterialInput
                        autoFocus
                        multiline
                        rows={4}
                        id="reason"
                        label="Enter Reason"
                        placeholder="Enter reason for not a bug"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={reasonText}
                        onChange={(e) => setReasonText(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <MaterialButton onClick={handleReasonClose}>Cancel</MaterialButton>
                    <MaterialButton variant="contained" color='dark' onClick={handleReasonSubmit} disabled={!reasonText.trim()}>Submit</MaterialButton>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    )
}

export default BugList
